<template>
  <div>
    <bclose-popup ref="popup1" @close="change">
      <div class="gift_pop">
        <img class="bg-img" src="@/assets/image/lottery/zb.png" mode="scaleToFill"  />
        <div class="title">恭喜中奖</div>
        <div class="gift-desc">{{ data.content }}</div>
        <div class="action-btn" @click="closePopup">{{ data.isAnswer ? '知道了' : '前往领取'}}</div>
      </div>
    </bclose-popup>
  </div>
</template>

<script>
export default {
  name: 'UniNew39TopicWinPopup',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {
    change(e) {
      setTimeout(() => {
        this.$store.commit('popup/setPagePopupData', {})
      },300)
    },
    closePopup() {
      this.$refs.popup1.close();
      if(this.data.isAnswer) return
      this.$router.push('/pages/user/awardPage/awardPage')
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.$refs.popup1.open();
      } else {
        this.$refs.popup1.close();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gift_pop {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 2.05rem;
  padding-top: 0.05rem;
  .bg-img {
    width: 15rem;
    height: 2.6rem;
    position: absolute;
    top: 0.25rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .title {
    font-size: 1rem;
    font-weight: bold;
    color: #1d1d1d;
    margin-bottom: 1rem;
    line-height: 1;
  }

  .gift-img {
    width: 2.5rem;
    height: 2.5rem;
    margin-bottom: 0.75rem;
    border-radius: 0.25rem;
  }

  .gift-desc {
    font-size: 0.6rem;
    color: #1d1d1d;
    margin-bottom: 0.5rem;
    line-height: 0.8rem;
    text-align: center;
  }

  .action-btn {
    width: 7.5rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    background: linear-gradient(271deg, #1d1d1d 0%, #5b4e3f 100%);
    border-radius: 1rem;
    color: #fbd37d;
    font-size: 0.7rem;
    margin-top: 0.5rem;
  }
}
</style>